import init from './src/init';
init();
